export const findNextIntDivisibleBy = (start: number, by = 5) => {
  let n = start;
  while (n % by !== 0) {
    n++;
  }
  return n;
};
